<template>
  <div class="mod-config">
    <el-row :gutter="20">
      <el-col :span="10">
        <el-card shadow="never">
          <div slot="header">{{ $t('notification.sendMessage') }}</div>
          <el-form :model="sendForm" label-width="100px">
            <el-form-item :label="$t('notification.channel')">
              <el-select v-model="sendForm.type" :placeholder="$t('notification.selectChannel')">
                <el-option :label="$t('notification.sms')" value="SMS" />
                <el-option :label="$t('notification.email')" value="EMAIL" />
                <el-option :label="$t('notification.push')" value="PUSH" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('notification.template')">
              <el-select v-model="sendForm.template" :placeholder="$t('notification.selectTemplate')" filterable clearable @change="applyTemplate">
                <el-option v-for="tpl in templates" :key="tpl.id" :label="tpl.name" :value="tpl.id" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('notification.title')" v-if="sendForm.type!=='SMS'">
              <el-input v-model="sendForm.title" :placeholder="$t('notification.inputTitle')" />
            </el-form-item>
            <el-form-item :label="$t('notification.content')">
              <el-input type="textarea" :rows="6" v-model="sendForm.content" :placeholder="$t('notification.inputContentWithVars')" />
            </el-form-item>
            <el-form-item :label="$t('notification.receivers')">
              <el-checkbox v-model="sendForm.isBroadcast" @change="handleBroadcastChange">{{ $t('notification.broadcastAll') }}</el-checkbox>
              <el-select v-model="sendForm.userIds" multiple filterable remote reserve-keyword :remote-method="remoteSearchUsers" :loading="userLoading" :placeholder="$t('notification.searchUsersPlaceholder')" :disabled="sendForm.isBroadcast">
                <el-option v-for="u in userOptions" :key="u.id" :label="u.label" :value="u.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="send">{{ $t('common.send') }}</el-button>
              <el-button @click="resetSendForm">{{ $t('common.reset') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="14">
        <el-card shadow="never">
          <div slot="header">{{ $t('notification.sendRecords') }}</div>
          <el-form :inline="true" :model="queryForm" @keyup.enter.native="getRecords()">
            <el-form-item>
              <el-select v-model="queryForm.type" :placeholder="$t('notification.channelShort')" clearable style="width: 120px">
                <el-option :label="$t('notification.sms')" value="SMS" />
                <el-option :label="$t('notification.email')" value="EMAIL" />
                <el-option :label="$t('notification.push')" value="PUSH" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="queryForm.businessType" :placeholder="$t('notification.businessType')" clearable style="width: 130px">
                <el-option :label="$t('notification.system')" value="SYSTEM" />
                <el-option :label="$t('notification.appointment')" value="APPOINTMENT" />
                <el-option :label="$t('notification.expiration')" value="EXPIRATION" />
                <el-option :label="$t('notification.promotion')" value="PROMOTION" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" :start-placeholder="$t('notification.startTime')" :end-placeholder="$t('notification.endTime')" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="queryForm.title" :placeholder="$t('notification.title')" clearable />
            </el-form-item>
            <el-form-item>
              <el-button @click="getRecords">{{ $t('common.search') }}</el-button>
              <el-button @click="resetQuery">{{ $t('common.reset') }}</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="records" border v-loading="loading" style="width: 100%">
            <el-table-column prop="id" :label="$t('table.id')" width="70" align="center" />
            <el-table-column prop="type" :label="$t('notification.channelShort')" width="90" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type==='SMS'" type="warning">{{ $t('notification.sms') }}</el-tag>
                <el-tag v-else-if="scope.row.type==='EMAIL'" type="info">{{ $t('notification.email') }}</el-tag>
                <el-tag v-else type="success">{{ $t('notification.push') }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('notification.title')" min-width="160" />
            <el-table-column prop="content" :label="$t('notification.content')" min-width="220" show-overflow-tooltip />
            <el-table-column prop="userId" :label="$t('notification.userId')" width="90" align="center" />
            <el-table-column prop="status" :label="$t('common.status')" width="90" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status===1?'success':(scope.row.status===2?'danger':'info')">
                  {{ scope.row.status===1?$t('notification.sent'):(scope.row.status===2?$t('notification.failed'):$t('notification.pending')) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" :label="$t('notification.sendTime')" width="170" />
          </el-table>
          <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pageIndex" :page-sizes="[10,20,50,100]" :page-size="pageSize" :total="total" layout="total, sizes, prev, pager, next, jumper" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 发送
      sendForm: { type: 'SMS', template: '', title: '', content: '', userIds: [], isBroadcast: false },
      templates: [
        { id: 'appointment', name: this.$t('notification.tplAppointment'), title: this.$t('notification.tplAppointment'), content: this.$t('notification.tplAppointmentContent') },
        { id: 'expiration', name: this.$t('notification.tplExpiration'), title: this.$t('notification.tplExpiration'), content: this.$t('notification.tplExpirationContent') },
        { id: 'promotion', name: this.$t('notification.tplPromotion'), title: this.$t('notification.tplPromotion'), content: this.$t('notification.tplPromotionContent') }
      ],
      userOptions: [],
      userLoading: false,
      // 查询
      searchType: '',
      queryForm: { type: '', businessType: '', userId: '', title: '' },
      dateRange: [],
      records: [],
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    applyTemplate (tplId) {
      const tpl = this.templates.find(t => t.id === tplId)
      if (tpl) {
        if (this.sendForm.type !== 'SMS') this.sendForm.title = tpl.title
        this.sendForm.content = tpl.content
      }
    },
    remoteSearchUsers (keyword) {
      this.userLoading = true
      this.$http({ url: '/yonghu/list', method: 'get', params: { page: 1, limit: 20, key: keyword } })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.userOptions = (data.data.list || []).map(u => ({ id: u.id, label: `${u.zhanghao || ''} ${u.xingming || ''} ${u.shouji || ''}` }))
          }
          this.userLoading = false
        }).catch(() => { this.userLoading = false })
    },
    send () {
      if (!this.sendForm.userIds.length && !this.sendForm.isBroadcast) { 
        this.$message.warning(this.$t('notification.selectUsersOrBroadcast')); 
        return 
      }
      let title = this.sendForm.title;
      if (!title && this.sendForm.type !== 'SMS') {
        title = this.$t('notification.defaultTitle');
      }
      const payload = {
        type: this.sendForm.type,
        title: title,
        content: this.sendForm.content || '',
        businessType: 'SYSTEM',
        businessId: 0,
        userIds: this.sendForm.userIds,
        isBroadcast: this.sendForm.isBroadcast
      }
      console.log(this.$t('notification.sendingPayload'), payload);
      this.$http({ 
        url: '/notification/send/custom', 
        method: 'post', 
        data: payload 
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message.success(this.$t('notification.sendSuccess'))
          this.getRecords()
        } else {
          if (data.success !== undefined && data.total !== undefined) {
            this.$message.warning(this.$t('notification.sendSummary', { success: data.success, failed: data.total - data.success }))
          } else {
            this.$message.error(data.msg || this.$t('notification.sendFailed'))
          }
        }
      }).catch(() => {
        this.$message.error(this.$t('notification.sendFailed'))
      })
    },
    handleBroadcastChange (val) {
      if (val) {
        this.sendForm.userIds = [];
      } else {
        if (!this.sendForm.userIds.length) {
          this.remoteSearchUsers('');
        }
      }
    },
    resetSendForm () {
      this.sendForm = { type: 'SMS', template: '', title: '', content: '', userIds: [], isBroadcast: false }
    },
    getRecords () {
      this.loading = true
      const params = { page: this.pageIndex, limit: this.pageSize }
      if (this.queryForm.type) params.type = this.queryForm.type
      if (this.queryForm.businessType) params.businessType = this.queryForm.businessType
      if (this.queryForm.userId) params.userId = this.queryForm.userId
      if (this.queryForm.title) params.title = this.queryForm.title
      if (this.dateRange && this.dateRange.length === 2) {
        params.send_time_start = this.dateRange[0]
        params.send_time_end = this.dateRange[1]
      }
      this.$http({ url: '/notification/pageAdmin', method: 'get', params }).then(({ data }) => {
        if (data && data.code === 0) {
          this.records = data.data.list || []
          this.total = data.data.total || 0
        } else {
          this.records = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => { this.records = []; this.total = 0; this.loading = false })
    },
    sizeChange (val) { this.pageSize = val; this.pageIndex = 1; this.getRecords() },
    pageChange (val) { this.pageIndex = val; this.getRecords() },
    resetQuery () { this.queryForm = { type: '', businessType: '', userId: '', title: '' }; this.dateRange = []; this.getRecords() }
  },
  created () {
    this.getRecords()
  }
}
</script>

<style scoped>
.mod-config { padding: 20px; }
</style>


